const APPAREL_SIZES = ["XS", "S", "M", "L", "XL"];
const EXTENDED_SIZES = ["XS", "S", "M", "L", "XL", "XXL"];
const ONE_SIZE = ["One Size"];

const makeProduct = (product) => {
  const image =
    "/img/product-" + String(product.id).padStart(2, "0") + ".webp";

  return {
    reviews: 0,
    rating: 4.8,
    ...product,
    image,
    images: [image],
  };
};

const productData = [
  makeProduct({
    id: 1,
    name: "Weekend Shorts - Beige Chino",
    category: "Shorts",
    price: 255,
    compareAtPrice: null,
    reviews: 48,
    rating: 4.8,
    size: APPAREL_SIZES,
    colors: ["Beige Chino", "Navy Chino", "Army Green Chino"],
    material: "100% cotton chino",
    description: [
      "Relaxed warm-weather shorts cut with enough room for active days and easy weekends.",
      "The softly washed chino develops a comfortable, lived-in character with regular wear.",
    ],
    Features: [
      "Elasticated back waist",
      "Integrated webbing belt",
      "Deep side pockets",
      "Prewashed for a stable fit",
    ],
    attributes: {
      fit: "Relaxed",
      rise: "Mid rise",
      inseam: "7 in",
      origin: "Made in Japan",
      care: "Machine wash cold",
    },
    tags: ["shorts", "chino", "summer", "featured"],
    inStock: true,
    featured: true,
    newArrival: true,
  }),
  makeProduct({
    id: 2,
    name: "Weekend Shorts - Navy Chino",
    category: "Shorts",
    price: 255,
    compareAtPrice: null,
    reviews: 41,
    rating: 4.7,
    size: APPAREL_SIZES,
    colors: ["Navy Chino", "Beige Chino", "Black Chino"],
    material: "100% cotton chino",
    description: [
      "A deep navy version of the everyday Weekend Shorts with a clean outdoor-sports profile.",
      "Durable midweight cotton balances structure, breathability and a soft hand.",
    ],
    Features: [
      "Elasticated back waist",
      "Integrated webbing belt",
      "Two front and two rear pockets",
      "Garment washed finish",
    ],
    attributes: {
      fit: "Relaxed",
      rise: "Mid rise",
      inseam: "7 in",
      origin: "Made in Japan",
      care: "Machine wash cold",
    },
    tags: ["shorts", "chino", "navy", "new-season"],
    inStock: true,
    featured: true,
    newArrival: true,
  }),
  makeProduct({
    id: 3,
    name: "Weekend Shorts - Army Green Chino",
    category: "Shorts",
    price: 255,
    compareAtPrice: null,
    reviews: 36,
    rating: 4.8,
    size: APPAREL_SIZES,
    colors: ["Army Green Chino", "Beige Chino", "Navy Chino"],
    material: "100% cotton chino",
    description: [
      "Utility-inspired shorts in a versatile green tone designed for city walks and trail breaks.",
      "A relaxed leg and adjustable waist keep the silhouette comfortable without looking oversized.",
    ],
    Features: [
      "Adjustable webbing waist",
      "Reinforced pocket openings",
      "Roomy straight leg",
      "Soft garment wash",
    ],
    attributes: {
      fit: "Relaxed",
      rise: "Mid rise",
      inseam: "7 in",
      origin: "Made in Japan",
      care: "Machine wash cold",
    },
    tags: ["shorts", "chino", "utility", "green"],
    inStock: true,
    featured: false,
    newArrival: true,
  }),
  makeProduct({
    id: 4,
    name: "Weekend Shorts - Khaki Green Dungaree",
    category: "Shorts",
    price: 255,
    compareAtPrice: null,
    reviews: 29,
    rating: 4.6,
    size: APPAREL_SIZES,
    colors: ["Khaki Green Dungaree", "Blue Dungaree"],
    material: "100% cotton dungaree",
    description: [
      "The familiar Weekend shape recut in textured dungaree for a sturdier workwear feel.",
      "Khaki-green yarns give the surface subtle depth while the fabric softens over time.",
    ],
    Features: [
      "Textured dungaree weave",
      "Elasticated back waist",
      "Integrated webbing belt",
      "Bartack reinforced pockets",
    ],
    attributes: {
      fit: "Relaxed",
      rise: "Mid rise",
      inseam: "7 in",
      origin: "Made in Japan",
      care: "Wash with similar colors",
    },
    tags: ["shorts", "dungaree", "workwear", "summer"],
    inStock: true,
    featured: false,
    newArrival: true,
  }),
  makeProduct({
    id: 5,
    name: "Active Lazy Shorts - Black Botanical",
    category: "Shorts",
    price: 195,
    compareAtPrice: null,
    reviews: 53,
    rating: 4.9,
    size: APPAREL_SIZES,
    colors: ["Black Botanical", "Black Chino", "Navy Chino"],
    material: "Cotton poplin",
    description: [
      "Lightweight pull-on shorts printed with an original tonal botanical pattern.",
      "Designed to move easily from a morning swim to an afternoon in the city.",
    ],
    Features: [
      "Quick-adjust drawcord waist",
      "Mesh-lined side pockets",
      "Rear snap pocket",
      "Fast-drying lightweight fabric",
    ],
    attributes: {
      fit: "Easy",
      rise: "Mid rise",
      inseam: "6 in",
      origin: "Made in Japan",
      care: "Gentle machine wash",
    },
    tags: ["shorts", "botanical", "active", "featured"],
    inStock: true,
    featured: true,
    newArrival: true,
  }),
  makeProduct({
    id: 6,
    name: "Active Lazy Shorts - Beige Chino",
    category: "Shorts",
    price: 195,
    compareAtPrice: null,
    reviews: 44,
    rating: 4.7,
    size: APPAREL_SIZES,
    colors: ["Beige Chino", "Army Green Chino", "Black Chino"],
    material: "100% cotton chino",
    description: [
      "An uncomplicated pull-on short made for travel, lounging and everyday errands.",
      "Compact cotton chino gives the casual silhouette a crisp, dependable finish.",
    ],
    Features: [
      "Elastic drawcord waist",
      "Angled hand pockets",
      "Secure rear pocket",
      "Prewashed cotton",
    ],
    attributes: {
      fit: "Easy",
      rise: "Mid rise",
      inseam: "6 in",
      origin: "Made in Japan",
      care: "Machine wash cold",
    },
    tags: ["shorts", "chino", "travel", "everyday"],
    inStock: true,
    featured: false,
    newArrival: true,
  }),
  makeProduct({
    id: 7,
    name: "Local Shorts - Natural",
    category: "Shorts",
    price: 245,
    compareAtPrice: null,
    reviews: 25,
    rating: 4.7,
    size: APPAREL_SIZES,
    colors: ["Natural", "Orange", "Indigo"],
    material: "Cotton-linen canvas",
    description: [
      "Easy utility shorts in an undyed natural canvas with a softly irregular texture.",
      "The roomy cut and practical pocketing are built for warm neighborhood days.",
    ],
    Features: [
      "Breathable cotton-linen cloth",
      "Elasticated waist",
      "Oversized patch pockets",
      "Natural corozo buttons",
    ],
    attributes: {
      fit: "Roomy",
      rise: "Regular rise",
      inseam: "7.5 in",
      origin: "Made in Japan",
      care: "Machine wash cold",
    },
    tags: ["shorts", "natural", "canvas", "summer"],
    inStock: true,
    featured: false,
    newArrival: true,
  }),
  makeProduct({
    id: 8,
    name: "Local Shorts - Orange",
    category: "Shorts",
    price: 245,
    compareAtPrice: null,
    reviews: 22,
    rating: 4.6,
    size: APPAREL_SIZES,
    colors: ["Orange", "Natural", "Sky Blue"],
    material: "Cotton-linen canvas",
    description: [
      "A sun-faded orange utility short that brings color to simple summer layers.",
      "The breathable canvas has enough body for daily wear while remaining comfortable in heat.",
    ],
    Features: [
      "Breathable cotton-linen cloth",
      "Elasticated waist",
      "Generous patch pockets",
      "Garment dyed finish",
    ],
    attributes: {
      fit: "Roomy",
      rise: "Regular rise",
      inseam: "7.5 in",
      origin: "Made in Japan",
      care: "Wash separately before wear",
    },
    tags: ["shorts", "orange", "canvas", "new-season"],
    inStock: true,
    featured: false,
    newArrival: true,
  }),
  makeProduct({
    id: 9,
    name: "Local Shorts - Indigo",
    category: "Shorts",
    price: 245,
    compareAtPrice: null,
    reviews: 31,
    rating: 4.8,
    size: APPAREL_SIZES,
    colors: ["Indigo", "Natural", "Bordeaux"],
    material: "Indigo-dyed cotton canvas",
    description: [
      "Utility shorts dyed a rich indigo that will reveal a personal fade pattern over time.",
      "An easy shape and substantial canvas make them suitable for both work and weekends.",
    ],
    Features: [
      "Indigo-dyed cotton",
      "Elasticated waist",
      "Large utility pockets",
      "Reinforced stress points",
    ],
    attributes: {
      fit: "Roomy",
      rise: "Regular rise",
      inseam: "7.5 in",
      origin: "Made in Japan",
      care: "Wash separately in cold water",
    },
    tags: ["shorts", "indigo", "canvas", "utility"],
    inStock: true,
    featured: false,
    newArrival: true,
  }),
  makeProduct({
    id: 10,
    name: "Five Pocket Island Shirt - Khaki Green Dungaree",
    category: "Shirts",
    price: 295,
    compareAtPrice: null,
    reviews: 39,
    rating: 4.8,
    size: APPAREL_SIZES,
    colors: ["Khaki Green Dungaree", "Blue Dungaree"],
    material: "100% cotton dungaree",
    description: [
      "A relaxed short-sleeve shirt organized with five useful pockets for days spent outside.",
      "Textured green dungaree adds workwear character to the open summer silhouette.",
    ],
    Features: [
      "Five functional pockets",
      "Open camp collar",
      "Straight vented hem",
      "Natural corozo buttons",
    ],
    attributes: {
      fit: "Relaxed",
      sleeve: "Short sleeve",
      collar: "Camp collar",
      origin: "Made in Japan",
      care: "Machine wash cold",
    },
    tags: ["shirts", "dungaree", "camp-collar", "featured"],
    inStock: true,
    featured: true,
    newArrival: true,
  }),
  makeProduct({
    id: 11,
    name: "Five Pocket Island Shirt - Blue Dungaree",
    category: "Shirts",
    price: 295,
    compareAtPrice: null,
    reviews: 34,
    rating: 4.7,
    size: APPAREL_SIZES,
    colors: ["Blue Dungaree", "Khaki Green Dungaree"],
    material: "100% cotton dungaree",
    description: [
      "A pocket-rich island shirt in blue dungaree, designed as a light layer for long summer days.",
      "The cloth has a subtle slub and softens while retaining its sturdy shape.",
    ],
    Features: [
      "Five functional pockets",
      "Open camp collar",
      "Straight vented hem",
      "Double-needle construction",
    ],
    attributes: {
      fit: "Relaxed",
      sleeve: "Short sleeve",
      collar: "Camp collar",
      origin: "Made in Japan",
      care: "Wash with similar colors",
    },
    tags: ["shirts", "blue", "dungaree", "summer"],
    inStock: true,
    featured: false,
    newArrival: true,
  }),
  makeProduct({
    id: 12,
    name: "Sport Pullover - White",
    category: "Outerwear",
    price: 280,
    compareAtPrice: null,
    reviews: 57,
    rating: 4.9,
    size: APPAREL_SIZES,
    colors: ["White", "Navy", "Forest Green", "Red", "Black"],
    material: "Water-resistant cotton-nylon poplin",
    description: [
      "A lightweight half-zip pullover inspired by classic training shells and shoreline windbreakers.",
      "The crisp white fabric layers easily and offers protection from a cool breeze or brief shower.",
    ],
    Features: [
      "Half-zip funnel neck",
      "Large front utility pocket",
      "Adjustable hem drawcord",
      "Light water resistance",
    ],
    attributes: {
      fit: "Relaxed",
      weight: "Lightweight",
      weather: "Wind and light rain",
      origin: "Made in Japan",
      care: "Gentle machine wash",
    },
    tags: ["outerwear", "pullover", "lightweight", "featured"],
    inStock: true,
    featured: true,
    newArrival: true,
  }),
  makeProduct({
    id: 13,
    name: "Canyon Shirt Jacket - Brown Corduroy",
    category: "Shirts",
    price: 172.5,
    compareAtPrice: 345,
    reviews: 32,
    rating: 4.7,
    size: APPAREL_SIZES,
    colors: ["Brown Corduroy"],
    material: "100% cotton corduroy",
    description: [
      "A substantial overshirt in warm brown corduroy that works as a shirt or lightweight jacket.",
      "The relaxed construction leaves room for a tee or sweatshirt underneath.",
    ],
    Features: [
      "Wide-wale corduroy",
      "Dual chest pockets",
      "Side-entry hand pockets",
      "Button-adjustable cuffs",
    ],
    attributes: {
      fit: "Relaxed",
      weight: "Midweight",
      collar: "Point collar",
      origin: "Made in Japan",
      care: "Machine wash inside out",
    },
    tags: ["shirts", "shirt-jacket", "corduroy", "sale"],
    inStock: false,
    featured: false,
    newArrival: false,
  }),
  makeProduct({
    id: 14,
    name: "Pocket-On Tee - Navy",
    category: "Tees",
    price: 90,
    compareAtPrice: null,
    reviews: 66,
    rating: 4.8,
    size: EXTENDED_SIZES,
    colors: ["Navy", "Mocha", "Black", "White"],
    material: "100% heavyweight cotton jersey",
    description: [
      "A dependable navy pocket tee cut from dense jersey with a dry, substantial hand.",
      "Its balanced shape sits neatly on its own and layers comfortably under overshirts.",
    ],
    Features: [
      "Reinforced chest pocket",
      "Rib-bound crew neck",
      "Twin-needle hems",
      "Prewashed to reduce shrinkage",
    ],
    attributes: {
      fit: "Regular",
      weight: "Heavyweight",
      neckline: "Crew neck",
      origin: "Made in Japan",
      care: "Machine wash cold",
    },
    tags: ["tees", "pocket-tee", "navy", "essentials"],
    inStock: true,
    featured: false,
    newArrival: false,
  }),
  makeProduct({
    id: 15,
    name: "Pocket-On Tee - Mocha",
    category: "Tees",
    price: 90,
    compareAtPrice: null,
    reviews: 51,
    rating: 4.7,
    size: EXTENDED_SIZES,
    colors: ["Mocha", "Navy", "Black", "White"],
    material: "100% heavyweight cotton jersey",
    description: [
      "A warm mocha pocket tee made from durable cotton jersey with a soft washed surface.",
      "The clean regular fit is easy to wear with shorts, fatigues or layered outerwear.",
    ],
    Features: [
      "Reinforced chest pocket",
      "Rib-bound crew neck",
      "Twin-needle hems",
      "Garment washed finish",
    ],
    attributes: {
      fit: "Regular",
      weight: "Heavyweight",
      neckline: "Crew neck",
      origin: "Made in Japan",
      care: "Machine wash cold",
    },
    tags: ["tees", "pocket-tee", "mocha", "essentials"],
    inStock: true,
    featured: false,
    newArrival: false,
  }),
  makeProduct({
    id: 16,
    name: "Team S/S Pocket Tee - Mustard x Red",
    category: "Tees",
    price: 32.5,
    compareAtPrice: 65,
    reviews: 28,
    rating: 4.6,
    size: APPAREL_SIZES,
    colors: ["Mustard x Red"],
    material: "100% cotton jersey",
    description: [
      "A vintage-team inspired pocket tee pairing a warm mustard body with restrained red details.",
      "Soft jersey and an easy fit make it a comfortable everyday layer.",
    ],
    Features: [
      "Contrast pocket detail",
      "Soft rib crew neck",
      "Prewashed cotton jersey",
      "Straight hem",
    ],
    attributes: {
      fit: "Regular",
      weight: "Midweight",
      neckline: "Crew neck",
      origin: "Made in USA",
      care: "Machine wash cold",
    },
    tags: ["tees", "pocket-tee", "team", "sale"],
    inStock: true,
    featured: false,
    newArrival: false,
  }),
  makeProduct({
    id: 17,
    name: "Active Lazy Pants - Brown Corduroy",
    category: "Pants",
    price: 275,
    compareAtPrice: null,
    reviews: 47,
    rating: 4.8,
    size: APPAREL_SIZES,
    colors: ["Brown Corduroy", "Navy Corduroy"],
    material: "100% cotton corduroy",
    description: [
      "Relaxed pull-on pants in soft brown corduroy, equally suited to travel and daily wear.",
      "A gentle taper keeps the roomy top block tidy through the leg.",
    ],
    Features: [
      "Elastic drawcord waist",
      "Deep hand pockets",
      "Secure rear pocket",
      "Soft garment wash",
    ],
    attributes: {
      fit: "Relaxed tapered",
      rise: "Mid rise",
      leg: "Straight taper",
      origin: "Made in Japan",
      care: "Machine wash inside out",
    },
    tags: ["pants", "corduroy", "travel", "featured"],
    inStock: true,
    featured: true,
    newArrival: false,
  }),
  makeProduct({
    id: 18,
    name: "Step-Up Sweatpants V.2 - Navy",
    category: "Sweats",
    price: 125,
    compareAtPrice: 250,
    reviews: 61,
    rating: 4.8,
    size: APPAREL_SIZES,
    colors: ["Navy", "Heather Grey", "Olive"],
    material: "100% cotton fleece",
    description: [
      "Structured navy sweatpants made from substantial fleece for warmth without excessive bulk.",
      "The updated pattern offers easy movement through the seat and a clean tapered leg.",
    ],
    Features: [
      "Soft brushed interior",
      "Elastic drawcord waist",
      "Ribbed ankle cuffs",
      "Reinforced side pockets",
    ],
    attributes: {
      fit: "Relaxed tapered",
      weight: "Heavyweight",
      rise: "Mid rise",
      origin: "Made in Japan",
      care: "Machine wash cold",
    },
    tags: ["sweats", "sweatpants", "navy", "sale"],
    inStock: true,
    featured: false,
    newArrival: false,
  }),
  makeProduct({
    id: 19,
    name: "Zip Reach-Up Hoody V.2 - Heather Grey",
    category: "Sweats",
    price: 196,
    compareAtPrice: 280,
    reviews: 72,
    rating: 4.9,
    size: EXTENDED_SIZES,
    colors: ["Heather Grey", "Navy", "Black"],
    material: "12 oz 100% cotton fleece",
    description: [
      "A substantial zip hoody with a softly looped interior and an enduring athletic shape.",
      "Underarm gussets and a two-way front zip make it a practical year-round layer.",
    ],
    Features: [
      "Adjustable drawcord hood",
      "Two-way front zipper",
      "Diamond underarm gussets",
      "Ribbed cuffs and hem",
    ],
    attributes: {
      fit: "True to size",
      weight: "12 oz heavyweight",
      closure: "Two-way zip",
      origin: "Made in Japan",
      care: "Machine wash cold",
    },
    tags: ["sweats", "hoody", "fleece", "sale"],
    inStock: true,
    featured: true,
    newArrival: false,
  }),
  makeProduct({
    id: 20,
    name: "Club Cap (Mesh Back) - Postal Blue",
    category: "Hats",
    price: 65,
    compareAtPrice: null,
    reviews: 38,
    rating: 4.7,
    size: ONE_SIZE,
    colors: ["Postal Blue"],
    material: "Cotton twill with polyester mesh",
    description: [
      "A breathable five-panel club cap in clear postal blue with a light mesh back.",
      "Its flexible brim and adjustable closure make it an easy packable companion.",
    ],
    Features: [
      "Breathable mesh back",
      "Adjustable rear strap",
      "Flexible curved brim",
      "Embroidered front detail",
    ],
    attributes: {
      fit: "Adjustable",
      crown: "Five panel",
      brim: "Curved",
      origin: "Made in USA",
      care: "Spot clean",
    },
    tags: ["hats", "cap", "mesh", "summer"],
    inStock: true,
    featured: false,
    newArrival: true,
  }),
  makeProduct({
    id: 21,
    name: "Watch Cap V.2 - Copper",
    category: "Hats",
    price: 30,
    compareAtPrice: null,
    reviews: 84,
    rating: 4.8,
    size: ONE_SIZE,
    colors: ["Copper", "Dark Red", "Black", "Orange"],
    material: "Soft acrylic rib knit",
    description: [
      "A compact rib-knit watch cap in a warm copper shade for cold commutes and trail mornings.",
      "The resilient yarn keeps its shape while remaining soft against the skin.",
    ],
    Features: [
      "Stretch rib construction",
      "Adjustable fold-over cuff",
      "Quick-drying yarn",
      "Packable lightweight design",
    ],
    attributes: {
      fit: "Stretch one size",
      knit: "Rib knit",
      warmth: "Medium",
      origin: "Made in USA",
      care: "Hand wash cold",
    },
    tags: ["hats", "watch-cap", "knit", "cold-weather"],
    inStock: false,
    featured: false,
    newArrival: false,
  }),
  makeProduct({
    id: 22,
    name: "Mini Packable Tote - Denim x Tan",
    category: "Bags",
    price: 70,
    compareAtPrice: null,
    reviews: 46,
    rating: 4.7,
    size: ONE_SIZE,
    colors: ["Denim x Tan", "Navy x Red", "Olive x Orange"],
    material: "Cotton denim and recycled nylon",
    description: [
      "A compact everyday tote combining a denim body with durable tan handles and trim.",
      "It folds into its own pocket for groceries, beach gear or an extra travel bag.",
    ],
    Features: [
      "Self-packing interior pocket",
      "Reinforced carry handles",
      "Snap top closure",
      "Lightweight unlined construction",
    ],
    attributes: {
      capacity: "12 L",
      dimensions: "32 x 28 x 12 cm",
      closure: "Snap",
      origin: "Made in Japan",
      care: "Spot clean",
    },
    tags: ["bags", "tote", "packable", "denim"],
    inStock: true,
    featured: false,
    newArrival: true,
  }),
  makeProduct({
    id: 23,
    name: "Packable Tote - Denim x Tan",
    category: "Bags",
    price: 75,
    compareAtPrice: null,
    reviews: 59,
    rating: 4.8,
    size: ONE_SIZE,
    colors: ["Denim x Tan", "Navy x Red", "Olive x Orange"],
    material: "Cotton denim and recycled nylon",
    description: [
      "A roomy packable tote designed to carry a full day of essentials without excess weight.",
      "The denim body gains character with use while reinforced tan handles support heavier loads.",
    ],
    Features: [
      "Folds into internal pocket",
      "Long shoulder-length handles",
      "Reinforced base panel",
      "Interior organizer pocket",
    ],
    attributes: {
      capacity: "22 L",
      dimensions: "42 x 36 x 14 cm",
      closure: "Open top",
      origin: "Made in Japan",
      care: "Spot clean",
    },
    tags: ["bags", "tote", "packable", "travel"],
    inStock: true,
    featured: false,
    newArrival: true,
  }),
  makeProduct({
    id: 24,
    name: "Travel Shell Parka V.3 - Beige x Navy",
    category: "Outerwear",
    price: 448,
    compareAtPrice: 640,
    reviews: 43,
    rating: 4.9,
    size: APPAREL_SIZES,
    colors: ["Beige x Navy"],
    material: "Three-layer waterproof nylon",
    description: [
      "A protective travel parka that pairs a neutral beige shell with deep navy utility panels.",
      "Its lightweight three-layer construction blocks weather while packing neatly for changing conditions.",
    ],
    Features: [
      "Seam-sealed three-layer shell",
      "Adjustable hood and hem",
      "Two-way front zipper",
      "Multiple secure travel pockets",
    ],
    attributes: {
      fit: "Relaxed layering fit",
      weather: "Waterproof and windproof",
      weight: "Lightweight",
      origin: "Made in Japan",
      care: "Technical wash cold",
    },
    tags: ["outerwear", "parka", "waterproof", "sale"],
    inStock: true,
    featured: true,
    newArrival: false,
  }),
  makeProduct({
    id: 25,
    name: "Beach Breaker - Navy",
    category: "Outerwear",
    price: 145,
    compareAtPrice: 290,
    reviews: 54,
    rating: 4.8,
    size: APPAREL_SIZES,
    colors: ["Navy", "Sage"],
    material: "Water-resistant cotton-nylon cloth",
    description: [
      "A clean navy windbreaker developed for cool beach evenings and unpredictable spring weather.",
      "The uncomplicated shape layers over shirts or sweats and packs down easily when the sun returns.",
    ],
    Features: [
      "Wind-resistant shell",
      "Stowable adjustable hood",
      "Two-way front zipper",
      "Elasticated cuffs",
    ],
    attributes: {
      fit: "Regular",
      weather: "Wind and light rain",
      weight: "Lightweight",
      origin: "Made in Japan",
      care: "Gentle machine wash",
    },
    tags: ["outerwear", "windbreaker", "navy", "sale"],
    inStock: true,
    featured: true,
    newArrival: false,
  }),
  makeProduct({
    id: 26,
    name: "Light Shell Parka - Sage",
    category: "Outerwear",
    price: 225,
    compareAtPrice: 475,
    reviews: 37,
    rating: 4.7,
    size: APPAREL_SIZES,
    colors: ["Sage"],
    material: "Lightweight waterproof nylon",
    description: [
      "A minimal sage parka designed as a dependable shell for damp commutes and weekend walks.",
      "The light technical fabric offers weather protection without overwhelming warm-weather layers.",
    ],
    Features: [
      "Waterproof lightweight shell",
      "Adjustable three-piece hood",
      "Covered front zipper",
      "Zipped hand pockets",
    ],
    attributes: {
      fit: "Relaxed",
      weather: "Waterproof and windproof",
      weight: "Lightweight",
      origin: "Made in Japan",
      care: "Technical wash cold",
    },
    tags: ["outerwear", "parka", "sage", "sale"],
    inStock: true,
    featured: false,
    newArrival: false,
  }),
];

export default productData;
